module.exports = __webpack_public_path__ + "img/iripple-logo-original.2c9371eb.svg";